import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './Introduction.module.sass';
import Button from '../../../ui_kit/button/Button';
import Footer from '../../../footer/components/footer/Footer';

function Introduction(props) {
  const { increaseStep } = props;

  const introductionElement = useMemo(() => document.querySelector('.introduction'), []);

  return (
    <>
      <div className="introduction" dangerouslySetInnerHTML={{ __html: introductionElement.innerHTML }} />
      <div className={styles.introduction}>
        <div className={styles['take-the-quiz']}>
          <div className={styles.background} />
          <div className={styles.title}>
            Think you’ve got what it takes to be a Volition Innovator?
            <br />
            Submit your Beauty idea today.
          </div>
          <Button
            className={styles.button}
            onClickHandler={increaseStep}
            text="TAKE THE INNOVATOR QUIZ"
            color="transparent-white"
            size="small"
          />
        </div>
      </div>
      <footer>
        <Footer />
      </footer>
    </>
  );
}

Introduction.propTypes = {
  increaseStep: PropTypes.func.isRequired,
};

export default Introduction;
